const ClassesSection = () => {
    return (
        <div className="space-y-6">
            <h2 className="text-2xl font-bold text-slate-900">📚 Lớp Học</h2>
            <p className="text-slate-700">
                Quản lý và tham gia các lớp học của bạn.
            </p>

            <div className="bg-white p-6 rounded-lg border border-slate-200">
                <h3 className="text-lg font-semibold text-slate-900 mb-4">Các tính năng:</h3>
                <div className="space-y-4">
                    <div className="p-4 border-l-4 border-indigo-500 bg-indigo-50">
                        <h4 className="font-semibold text-indigo-900">📋 Xem thông tin lớp</h4>
                        <p className="text-sm text-slate-700">Nhấn vào lớp học để xem chi tiết, lịch học, và danh sách học sinh</p>
                    </div>
                    <div className="p-4 border-l-4 border-green-500 bg-green-50">
                        <h4 className="font-semibold text-green-900">📄 Tải tài liệu</h4>
                        <p className="text-sm text-slate-700">Download tài liệu PDF, bài giảng do giáo viên cung cấp</p>
                    </div>
                    <div className="p-4 border-l-4 border-purple-500 bg-purple-50">
                        <h4 className="font-semibold text-purple-900">💬 Nhắn tin</h4>
                        <p className="text-sm text-slate-700">Gửi tin nhắn cho giáo viên hoặc các bạn học trong lớp</p>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ClassesSection;
